import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '@nx-ratenow/core/feature-auth';
import { PersonAuthDetailsDto } from '@nx-ratenow/shared/models';

export const getUserLoggedResolver: ResolveFn<PersonAuthDetailsDto> = (route, state, authService: AuthService = inject(AuthService)) => {
  return authService.getUserLogged();
};
